import { createFileRoute } from '@tanstack/react-router'
import { RegionalSection } from '../../../features/settings/admin-sections'
import { requireSection } from '../../../features/settings/guards'

export const Route = createFileRoute('/_app/settings/regional')({
  staticData: { crumb: 'settingsSection' },
  beforeLoad: ({ context }) => requireSection(context.session, 'regional'),
  component: RegionalSection,
})
